var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('dashboard-core-app-bar',{on:{"reload":_vm.forceRerender}}),_c('dashboard-core-drawer'),_c('dashboard-core-view',{attrs:{"render":_vm.render}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }